// extracted by mini-css-extract-plugin
export var card = "_lo-0";
export var content = "_lo-2";
export var details = "_lo-3";
export var icon = "_lo-1";
export var iconBlue = "_lo-5";
export var iconBrand = "_lo-4";
export var iconGrayBlue = "_lo-6";
export var iconGreen = "_lo-7";
export var iconIndigo = "_lo-8";
export var iconOrange = "_lo-9";
export var iconPurple = "_lo-a";
export var iconRed = "_lo-b";
export var iconWarning = "_lo-c";